import React, {useState, useRef} from 'react';
import {message, Modal, Row} from 'antd';
import './style.module.css';
import ButtonComponent from '../../../atoms/Buttons';
import GeneralModal, {GeneralModalRef} from '../../../molecules/Modals/general/component';
import ResetPasswordForm from '../../../molecules/Forms/ResetPassword/component';
import authService from '../../../../services/authService';

type FormProps = {
    visible: boolean;
    onClose: () => void;
    email: string;
};

const ResetPasswordDialog = ({visible, onClose}: FormProps) => {
    const generalModalRef = useRef<GeneralModalRef>(null);
    const [email, setEmail] = useState('');
    const [required, setRequired] = useState(false);

    const handleOk = async (event: React.FormEvent) => {
        event.preventDefault();
    };

    const handleEmailChange = (email: string) => {
        setEmail(email);
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        try {
            setRequired(true);
            const result = await authService.forgotPassword({'identifier': email});
            if (result.status === 200) {
                message.success('Request submitted successfully. Check your email.');
                onClose();
            }

        } catch (error: any) {
            message.error(error?.response?.data?.message);
        }
    };

    return (
        <Modal open={visible} onCancel={onClose} onOk={handleOk} centered maskClosable={false}
               footer={[
                   <ButtonComponent key={'create-button'} onClick={handleSubmit} label={'Submit'} buttonType={'primary'}
                   />
               ]}
               width={450}
        >
            <Row className={'loginForm'}>
                <ResetPasswordForm email={email} required={required} onEmailChange={handleEmailChange}
                                   onSubmit={handleSubmit}/>
            </Row>
            <GeneralModal ref={generalModalRef}/>
        </Modal>
    );
};

export default ResetPasswordDialog;